import './InformativeModal.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

function InformativeModal({ show, closeModal, children }) {
    return (
        <Modal 
            show={show} 
            onHide={closeModal}
            centered
            className="informative-modal"
        >
            <Modal.Header className="informative-modal-header">
                <Modal.Title>ℹ️ Informação</Modal.Title>
                <button 
                    type="button" 
                    className="close-button"
                    onClick={closeModal}
                    aria-label="Fechar"
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </Modal.Header>
            <Modal.Body className="informative-modal-body">
                {children}
            </Modal.Body>
            <Modal.Footer className="informative-modal-footer">
                <button 
                    type="button" 
                    className="btn-understand"
                    onClick={closeModal}
                >
                    Entendi
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default InformativeModal;